/* import __COLOCATED_TEMPLATE__ from './move-start-record-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class MoveStartRecordComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked destinationEvent = null;
	@tracked recordID = null;
	
	@action
	async destinationEventChanged(browserEvent)
	{		
		if(browserEvent.target.value == '-')
		{
			this.destinationEvent = null;
		}
		else
		{
			const event = await this.store.findRecord('Event', browserEvent.target.value, { reload: true });
			this.destinationEvent = event;
		}
	}
	
	@action
	async moveRecord()
	{	
		if(this.recordID != null)
		{
			const startTimingRecord = await this.store.findRecord('StartTimingRecord', this.recordID);
			
			startTimingRecord.EventId = this.destinationEvent;
			await startTimingRecord.save();
			this.recordID = null;
		}
	}
}
